import { Injectable } from '@angular/core';
import { TagBloc } from '@kbloc';
import { CardEventType } from '@ktypes/enums';
import { CardItem, SocialChallengeState, Status } from '@ktypes/models';
import { EMPTY, switchMap } from 'rxjs';
import { filter, take } from 'rxjs/operators';
import { SocialChallengeBloc } from './social-challenge.bloc';

export const CANCEL_ANIMATION_TIME = 1000;

@Injectable({
  providedIn: 'root',
})
export class SocialChallengeCompletion {
  constructor(private _socialChallengeBloc: SocialChallengeBloc, private _tagBloc: TagBloc) {}

  private _getChallengesStart: number;

  checkForCompletion(card: CardItem, cardEventType: CardEventType): void {
    const cardDomainKeys = card.domains?.map((domain) => domain.key) ?? [];
    if (cardDomainKeys.length === 0) {
      // don't do anything if there aren't any domains to match
      return;
    }

    // Filter if challenges are not enabled
    this._tagBloc.socialChallengeEnabled$
      .pipe(
        filter((socialChallengesEnabled) => socialChallengesEnabled),
        switchMap(() => {
          // each time this method is called (on card completion), ensure we have challenges loaded (and
          // load them if not), then grab the list of active challenges and check if card domains matched
          return this._socialChallengeBloc.challengesStatus$.pipe(
            filter((challengeStatus) => challengeStatus.status !== Status.starting),
            switchMap((challengeStatus) => {
              // TODO: remove console timer once it serves it's purpose (currently here to see if it should have shown but was too slow to fetch challenges)
              // eslint-disable-next-line no-restricted-syntax
              console.time('getChallenges');
              this._getChallengesStart = Date.now();
              // local is set initially, no challenges have been requested, get now
              if (challengeStatus?.status === Status.local) {
                this._socialChallengeBloc.getChallenges();
                return EMPTY;
              }
              return this._socialChallengeBloc.getChallengesByState$(SocialChallengeState.active);
            })
          );
        }),
        take(1)
      )
      .subscribe((challenges) => {
        // TODO: remove console timer once it serves it's purpose
        // eslint-disable-next-line no-restricted-syntax
        console.timeEnd('getChallenges');
        const getChallengesEnd = Date.now();
        const totalTime = getChallengesEnd - this._getChallengesStart;
        if (this._getChallengesStart && totalTime > CANCEL_ANIMATION_TIME) {
          // don't show the animation if had to get challenges and took more than CANCEL_ANIMATION_TIME
          delete this._getChallengesStart;
          console.warn('Took too long updating challenges, aborting celebration modal check');
          return;
        }
        delete this._getChallengesStart;
        const matchedChallenge = challenges?.find(
          (challenge) => challenge.individual.status.enrolled && cardDomainKeys.includes(challenge.domain.key)
        );
        if (matchedChallenge) {
          this._socialChallengeBloc.updateChallengeStateBasedOnActionChange(matchedChallenge, cardEventType);
        }
        // on no match, do nothing
      });
  }
}
